import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../../../utils/Context'
import PageLoader from '../../../../components/loader/PageLoader'
import { get } from '../../../../utils/Api'
import FormLoader from '../../../../components/loader/FormLoader'
import PaymentModal from './PaymentModal'
import Pagination from '../../../../components/pagination/Pagination'
import ChangePassword from './ChangePassword'
import CreateUser from '../customers/CreateUser'

function Home() {
  const {
    profile,
    notify,
    fetchAdminWallet,
    adminWalletLoading,
    adminWalletData,
    fetchUserProfile,
    profileLoading,
  } = useGlobalContext()
  const navigate = useNavigate()

  //<-------------- KPI --------------->
  const [KPI, setKPI] = useState<any>({})
  const [kpiLoading, setKpiLoading] = useState(true)

  function fetchKPI() {
    setKpiLoading(true)
    get('admin/kpis')
      .then((result: any) => {
        if (result.status === 200) {
          setKPI(result.data)
        } else {
          notify('error', result.message)
        }
        setKpiLoading(false)
      })
      .catch(() => {
        setKpiLoading(false)
      })
  }

  useEffect(() => {
    fetchKPI()
    fetchUserProfile()
    if (profile.role === 'super admin') {
      fetchAdminWallet()
    }
  }, [])
  //<-------------- Bookings --------------->
  const [bookings, setBookings] = useState<any>({ data: [] })
  const [bookingsLoading, setBookingsLoading] = useState(true)

  function fetchBookings() {
    setBookingsLoading(true)
    get('admin/bookings?page=1&limit=10')
      .then((result: any) => {
        if (result.status === 200) {
          setBookings(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }

  useEffect(() => {
    fetchBookings()
  }, [])

  //<-------------- Transactions --------------->
  const [transactions, setTransactions] = useState<any>({ transactions: [] })
  const [transactionsLoading, setTransactionsLoading] = useState(true)

  function fetchTransactions() {
    setTransactionsLoading(true)
    get('admin/transactions?page=1&limit=10')
      .then((result: any) => {
        if (result.status === 200) {
          setTransactions(result)
        } else {
          notify('error', result.message)
        }
        setTransactionsLoading(false)
      })
      .catch(() => {
        setTransactionsLoading(false)
      })
  }

  useEffect(() => {
    if (profile.role !== 'agent') {
      fetchTransactions()
    }
  }, [])

  //<-------------- Bookings --------------->
  const [yourBookings, setYourBookings] = useState<any>({ data: [] })
  const [yourBookingsLoading, setYourBookingsLoading] = useState(true)

  function fetchYourBookings(page: number, pageSize: number) {
    setYourBookingsLoading(true)
    get(
      `admin/bookings?creatorId=${profile._id}&page=${page}&limit=${pageSize}`
    )
      .then((result: any) => {
        if (result.status === 200) {
          setYourBookings(result)
        } else {
          notify('error', result.message)
        }
        setYourBookingsLoading(false)
      })
      .catch(() => {
        setYourBookingsLoading(false)
      })
  }

  useEffect(() => {
    if (!profileLoading) {
      fetchYourBookings(1, 10)
    }
  }, [profileLoading])

  // Pay Stack payment
  const [showPayment, setShowPayment] = useState(false)
  const [showCreateUser, setSetShowCreateUser] = useState(false)

  return kpiLoading ? (
    <div className='home'>
      <PageLoader position='center' />
    </div>
  ) : (
    <div className='home'>
      {showCreateUser && (
        <CreateUser
          fetchCustomers={null}
          close={() => setSetShowCreateUser(false)}
        />
      )}
      {showPayment && (
        <PaymentModal
          amount={profile.debt}
          usage='debt'
          close={() => {
            fetchTransactions()
            setShowPayment(false)
          }}
        />
      )}
      {profile.firstLogin && <ChangePassword />}

      <div className='home-head flex justify-between flex-wrap'>
        <div className='left flex justify-between flex-wrap'>
          {profile.role !== 'agent' ? (
            <>
              <div
                className='card'
                onClick={() => navigate('/admin/balance-customers')}
              >
                <p>Total Balance</p>
                <h2>₦{KPI.totalBalance.toLocaleString()}</h2>
              </div>
              <div
                className='card'
                onClick={() => navigate('/admin/customers')}
              >
                <p>Overall User Count</p>
                <h2>{KPI.userCount.toLocaleString()}</h2>
              </div>
              <div
                className='card'
                onClick={() => navigate('/admin/debt-customers')}
              >
                <p>Total Debts</p>
                <h2>₦{KPI.totalDebt.toLocaleString()}</h2>
              </div>
              <div className='card' onClick={() => navigate('/admin/bookings')}>
                <p>Overall Booking Count</p>
                <h2>{KPI.bookingCount.toLocaleString()}</h2>
              </div>
              <div className='card' onClick={() => navigate('/admin/bookings')}>
                <p>Overall Booking Value</p>
                <h2>
                  ₦{parseFloat(KPI.totalCharge.toFixed(2)).toLocaleString()}{' '}
                </h2>
              </div>
              <div className='card' onClick={() => navigate('/admin/bookings')}>
                <p>Monthly User count </p>
                <h2>
                  {parseFloat(
                    KPI.monthlyData.userCount.toFixed(2)
                  ).toLocaleString()}{' '}
                </h2>
              </div>
              <div className='card' onClick={() => navigate('/admin/bookings')}>
                <p>Monthly Valid Booking Count</p>
                <h2>
                  {parseFloat(
                    KPI.monthlyData.validBookingCount.toFixed(2)
                  ).toLocaleString()}{' '}
                </h2>
              </div>
              <div className='card' onClick={() => navigate('/admin/bookings')}>
                <p>Monthly Booking Value</p>
                <h2>
                  ₦
                  {parseFloat(
                    KPI.monthlyData.totalBookingValue.toFixed(2)
                  ).toLocaleString()}{' '}
                </h2>
              </div>
            </>
          ) : (
            <>
              <div className='card'>
                <p>Your Booking Count</p>
                <h2>{profile.bookings.toLocaleString()}</h2>
              </div>
              <div className='card'>
                <p>Your Booking Value</p>
                <h2>₦{profile.costs.toLocaleString()}</h2>
              </div>
              <div className='card'>
                <p>System Booking Count</p>
                <h2>{KPI.bookingCount.toLocaleString()}</h2>
              </div>
            </>
          )}
        </div>
        <div className='right'>
          <div
            className='card flex items-center'
            onClick={() => navigate('/admin/export')}
          >
            <div className='icon'>
              <Icon icon={'arcticons:emoji-airplane-departure'} />
            </div>
            <div className='texts'>
              <h2>Export Delivery</h2>
              <p>Book shipment pickup for international deliveries</p>
            </div>
          </div>
          <div
            className='card flex items-center'
            onClick={() => navigate('/admin/import')}
          >
            <div className='icon'>
              <Icon icon={'arcticons:emoji-airplane-arriving'} />
            </div>
            <div className='texts'>
              <h2>Import Delivery</h2>
              <p>
                Book shipment pickup from international locations for deliveries
                in Nigeria
              </p>
            </div>
          </div>
          <div
            className='card flex items-center'
            onClick={() => navigate('/admin/domestic')}
          >
            <div className='icon'>
              <Icon icon='material-symbols-light:delivery-truck-speed-outline-rounded' />
            </div>
            <div className='texts'>
              <h2>Domestic Delivery</h2>
              <p>Book shipment pickup for deliveries within Nigeria</p>
            </div>
          </div>
          <div
            className='card flex items-center'
            onClick={() => navigate('/admin/quick-quote')}
          >
            <div className='icon'>
              <Icon icon='mdi:calculator-variant' />
            </div>
            <div className='texts'>
              <h2>Quick Quote</h2>
              <p>
                Get a fast shipping estimate from package details and country
                codes
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='home_tag flex justify-between'>
        <span></span>
        <button onClick={() => setSetShowCreateUser(true)}>Create User</button>
      </div>
      {!adminWalletLoading && profile.role === 'super admin' && (
        <div className='aza flex justify-between items-center flex-wrap'>
          <div className='card'>
            <h3>Wallet Balance</h3>
            <p>₦{adminWalletData.balance.toLocaleString()}</p>
          </div>
          <div className='card'>
            <h3>Account Name</h3>
            <p>
              {adminWalletData.firstname} {adminWalletData.lastname}
            </p>
          </div>
          <div className='card'>
            <h3>Account Number</h3>
            <p>{adminWalletData.account_number}</p>
          </div>
          <div className='card'>
            <h3>Bank Name</h3>
            <p>{adminWalletData.bank}</p>
          </div>
        </div>
      )}
      <div className='home_tables'>
        <div className='left'>
          <div className='left_top'>
            <h2>Your Recent Bookings</h2>
          </div>
          {yourBookingsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {yourBookings.data.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {yourBookings.data.map((item: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => navigate(`/admin/booking/${item.id}`)}
                        key={item.id}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                          <p> {new Date(item.dateTime).toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount</h4>
                          <p>₦{item.amount.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Tracking ID</h4>
                          <p> {item.trackingId}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Delivery type</h4>
                          <p>{item.deliveryType}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <span className={`chip ${item.status.code}`}>
                            {item.status.description}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Date/Time</th>
                        <th>Amount</th>
                        <th>Tracking ID</th>
                        <th>Delivery Type</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {yourBookings.data.map((item: any, i: number) => (
                        <tr key={item.id}>
                          <td>{i + 1}</td>
                          <td className='count'>
                            {new Date(item.dateTime).toLocaleString()}
                          </td>
                          <td className='count'>
                            NGN {item.amount.toLocaleString()}
                          </td>
                          <td className='count'>{item.trackingId}</td>
                          <td className='count'>{item.deliveryType}</td>
                          <td>
                            <span className={`chip ${item.status.code}`}>
                              {item.status.description}
                            </span>
                          </td>
                          <td>
                            <span
                              onClick={() =>
                                navigate(`/admin/booking/${item.id}`)
                              }
                              className='view'
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={yourBookings.pagination.page}
                    totalCount={yourBookings.pagination.totalPages}
                    pageSize={yourBookings.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchYourBookings(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>You Don't have a Recent Booking To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className='home_tables'>
        <div className='left'>
          <div className='left_top'>
            <h2>System Recent Bookings</h2>
          </div>
          {bookingsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {bookings.data.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {bookings.data.map((item: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => navigate(`/admin/booking/${item.id}`)}
                        key={item.id}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                          <p> {new Date(item.dateTime).toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount</h4>
                          <p>₦{item.amount.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Tracking ID</h4>
                          <p> {item.trackingId}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Delivery type</h4>
                          <p>{item.deliveryType}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <span className={`chip ${item.status.code}`}>
                            {item.status.description}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Date/Time</th>
                        <th>Amount</th>
                        <th>Tracking ID</th>
                        <th>Delivery Type</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookings.data.map((item: any, i: number) => (
                        <tr key={item.id}>
                          <td>{i + 1}</td>
                          <td className='count'>
                            {new Date(item.dateTime).toLocaleString()}
                          </td>
                          <td className='count'>
                            NGN {item.amount.toLocaleString()}
                          </td>
                          <td className='count'>{item.trackingId}</td>
                          <td className='count'>{item.deliveryType}</td>
                          <td>
                            <span className={`chip ${item.status.code}`}>
                              {item.status.description}
                            </span>
                          </td>
                          <td>
                            <span
                              onClick={() =>
                                navigate(`/admin/booking/${item.id}`)
                              }
                              className='view'
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Recent Bookings To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {profile.role !== 'agent' && (
        <div className='home_tables'>
          <div className='left'>
            <div className='left_top'>
              <h2>Recent Transactions</h2>
            </div>
            {transactionsLoading ? (
              <FormLoader position='center' />
            ) : (
              <>
                {transactions.transactions.length > 0 ? (
                  <>
                    <div className='mobile-table'>
                      {transactions.transactions.map((item: any, i: number) => (
                        <div className='card' key={item._id}>
                          <div className='flex justify-between row'>
                            <div className='count flex items-center justify-center'>
                              {i + 1}
                            </div>
                            <p> {new Date(item.created_at).toLocaleString()}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Amount</h4>
                            <p>₦{item.amount.toLocaleString()}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Type</h4>
                            <p className={item.type}>{item.type}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Desc</h4>
                            <p>{item.usage}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Reference</h4>
                            <p>{item.reference}</p>
                          </div>

                          <div className='row flex justify-between'>
                            <h4>Status</h4>
                            <p className={item.status}>{item.status}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <table className='desktop-table'>
                      <thead>
                        <tr>
                          <th>S/N</th>
                          <th>Date/Time</th>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Reference</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions.transactions.map(
                          (item: any, i: number) => (
                            <tr key={item._id}>
                              <td>{i + 1}</td>
                              <td className='count'>
                                {new Date(item.created_at).toLocaleString()}
                              </td>
                              <td className='count'>
                                NGN {item.amount.toLocaleString()}
                              </td>
                              <td>{item.usage}</td>
                              <td>{item.reference}</td>
                              <td className={item.status}>{item.status}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <div className='empty flex justify-center'>
                    <div className='empty-cover'>
                      <Icon icon='la:clipboard-list' />
                      <h1>No Recent Transaction To Show</h1>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Home
